import { CoreModel } from '../core/core.model';
export class TabsModel extends CoreModel {
/**
 * Active card index
 */
activeCardIndex?: number;
/**
 * If to show card number as icon in card header button
 */
showCardNumberAsIcon?: boolean;
/**
 * If to show card number as prefix in card header button
 */
showCardNumberAsPrefix?: boolean;
/**
 * If to show card number before the label
 */
indexBefore?: boolean;
/**
 * Header position: above (default), right, below, left
 */
headerPosition?: string;
/**
 * @hidden 
 * It is the constructor for the TabsModel component. It takes the values to create the TabsModel object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function TabsModel_tsickle_Closure_declarations() {
/**
 * Active card index
 * @type {?}
 */
TabsModel.prototype.activeCardIndex;
/**
 * If to show card number as icon in card header button
 * @type {?}
 */
TabsModel.prototype.showCardNumberAsIcon;
/**
 * If to show card number as prefix in card header button
 * @type {?}
 */
TabsModel.prototype.showCardNumberAsPrefix;
/**
 * If to show card number before the label
 * @type {?}
 */
TabsModel.prototype.indexBefore;
/**
 * Header position: above (default), right, below, left
 * @type {?}
 */
TabsModel.prototype.headerPosition;
}

